import { InteractiveLink } from "@/components/InteractiveLink"

interface RailComponentProps {
  children?: React.ReactNode
  title?: string
  hideTitle?: boolean
  href?: string
  hrefLabel?: string
}

export const MarketRailComponent = ({ children, title, hideTitle, href, hrefLabel }: RailComponentProps) => {
  return (
    <div className="content-container relative mb-[20px] rounded-[40px] bg-white p-0 lg:mb-0 lg:py-[40px]">
      <div className="flex items-end justify-between px-6 lg:mb-[32px] lg:px-[40px]">
        {!hideTitle && <p className="font-manrope text-[18px] font-bold lg:text-[40px] lg:leading-[48px]">{title}</p>}
        <div className="flex grow justify-end">{!!href && !!hrefLabel && <InteractiveLink href={href}>{hrefLabel}</InteractiveLink>}</div>
      </div>
      <ul className="overflow-visible pr-0 pl-2 lg:pl-[40px]">{children}</ul>
    </div>
  )
}
